import {Divider, styled} from "@mui/material";
import {getNeonColor} from "../theme";


export const NeonDivider = styled(Divider)(({ theme }) => (
    {textAlign: 'center', width: '100%', fontWeight: 'bold',
        textShadow: `0 0 2px ${getNeonColor(theme)}`,
        color: getNeonColor(theme)})
);